import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import classNames from 'classnames';

import { getSelectOptions } from 'src/reducers/selectOptions';
import MemoList from 'src/features/Memos';
import { getOptionLabel, getGroupFullPathName } from 'src/utils/Utils';
import { formatDate } from 'src/utils/Date';
import Balloon from 'src/components/Balloon';
import { Alert } from 'jbc-front/components/icons';
import { withTranslation, useTranslation } from 'react-i18next';

import styles from './EmployeeTableRow.scss';

const EmployeeAlertIcon = ({ alertMessage } = this.props) => (
  <tr className={styles.alertWrapper}>
    <td className={styles.alert}>
      <Balloon className={styles.balloon}>{alertMessage}</Balloon>
      <Alert size={22} color={'#666'} />
    </td>
  </tr>
);

export class EmployeeTableRowComponent extends Component {
  // 必須項目が足りないときのエラーメッセージを作成する
  // 必須項目をすべて満たすときはnullを返す
  createAlertMessage(employee) {
    const alertMessageBase = this.props.t('features.Employees.components.EmployeeTableRow.is_not_set')
    if (!_.isEmpty(employee.joinedOn) && employee.hasPayrollRule) {
      return null;
    }
    const errorItems = [];
    if (_.isEmpty(employee.joinedOn)) {
      errorItems.push(this.props.t('features.Employees.components.EmployeeTableRow.first_day_at_work'));
    }
    if (!employee.hasPayrollRule) {
      errorItems.push(this.props.t('features.Employees.components.EmployeeTableRow.salary_rules_group'));
    }
    return `${errorItems.join('・')}${alertMessageBase}`;
  }
  render() {
    const { employee, clientEmploymentTypes, groups, positions, onClick, client, clientBranch, i18n } = this.props;

    const belong_office = clientBranch.map(data => (
      { value: data.id, label: data.officeName }
    ))
    belong_office.unshift({ value: -1, label: client.officeName });

    const alertMessage = this.createAlertMessage(employee);
    return (
      <React.Fragment>
        {alertMessage && <EmployeeAlertIcon alertMessage={alertMessage} />}
        <tr onClick={onClick} className={classNames('table-hover', { [styles.tableRowAlert]: alertMessage != null })}>
          <td>
            <MemoList employeeId={employee.id} />
          </td>
          <td>{employee.staffCode}</td>
          <td>
            {employee.fullName}
          </td>
          <td>{getOptionLabel(employee.clientBranchId)(belong_office)}</td>
          <td>{getOptionLabel(employee.employmentTypeId)(clientEmploymentTypes)}</td>
          <td>{!!employee.groupId && <div>{getGroupFullPathName(groups, employee.groupId)}</div>}</td>
          <td>{getOptionLabel(employee.positionId)(positions)}</td>
          <td>{formatDate(employee.joinedOn)}</td>
          <td>{formatDate(employee.resignedOn)}</td>

        </tr>
      </React.Fragment>
    );
  }
}

export default withTranslation()(connect(state => ({
  clientEmploymentTypes: getSelectOptions(state, 'employmentTypes'),
  groups: getSelectOptions(state, 'groups'),
  positions: getSelectOptions(state, 'positions'),
  client: getSelectOptions(state, 'client'),
  clientBranch: getSelectOptions(state, 'client_branch')
}))(EmployeeTableRowComponent));
